"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LanguagePicker = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function LanguagePicker(props) {
    var _this;
    _classCallCheck(this, LanguagePicker);
    _this = _callSuper(this, LanguagePicker, [props]);
    _this.state = {
      electedToChange: false,
      picked: null
    };
    return _this;
  }
  _inherits(LanguagePicker, _React$Component);
  return _createClass(LanguagePicker, [{
    key: "continueText",
    value: function continueText(lang) {
      this;
      switch (lang) {
        case 'es':
          return 'Continuar';
        case 'en':
        default:
          return 'Continue';
      }
    }
  }, {
    key: "language",
    value: function language(lang) {
      this;
      switch (lang) {
        case 'es':
          return 'Español';
        case 'en':
        default:
          return 'English';
      }
    }
  }, {
    key: "makeChoice",
    value: function makeChoice(lang) {
      this.setState({
        picked: lang
      });
    }
  }, {
    key: "electToChange",
    value: function electToChange(lang) {
      this.setState({
        electedToChange: true
      });
    }
  }, {
    key: "renderChoices",
    value: function renderChoices() {
      var _this2 = this;
      var choice = null;
      var choices = [];
      this.props.languages.forEach(function (lang) {
        var activeClass = _this2.state.picked === lang ? 'btn btn-success btn-lg active ' : 'btn btn-secondary btn-lg ';
        choice = /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: activeClass + _style["default"].choice,
          onClick: function onClick() {
            _this2.makeChoice(lang);
          },
          key: lang
        }, _this2.language(lang));
        choices.push(choice);
      }, this);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].choiceBlock
      }, choices);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        initialLanguage = _this$props.initialLanguage,
        onLanguagePicked = _this$props.onLanguagePicked,
        languages = _this$props.languages;

      // language choices
      var chooser = initialLanguage === null || this.state.electedToChange !== false ? this.renderChoices() : '';

      // continue button
      var button = '';
      var disabled = this.state.picked !== null || initialLanguage !== null && this.state.electedToChange === false ? false : true;
      if (this.state.picked !== null || initialLanguage !== null) {
        button = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].confirmBlock
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: 'btn btn-primary ' + _style["default"].confirm,
          disabled: disabled,
          onClick: function onClick() {
            onLanguagePicked(_this3.state.picked || initialLanguage);
          }
        }, this.continueText(this.state.picked || initialLanguage)));
      }

      // language change footnote action
      var changer = '';
      var selectedText = {
        en: 'Selected language is ',
        es: 'El idioma seleccionado es '
      };
      var changeText = {
        en: 'Change language',
        es: 'Cambiar idioma'
      };
      var showChange = [changeText[initialLanguage]];
      var otherLanguages = (0, _omit2["default"])((0, _pick2["default"])(changeText, languages), initialLanguage);
      showChange = showChange.concat(Object.values(otherLanguages)).join(' / ');
      if (initialLanguage !== null && !this.state.electedToChange) {
        changer = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].changeBlock
        }, selectedText[initialLanguage], " ", this.language(initialLanguage), " \u2014", ' ', /*#__PURE__*/_react["default"].createElement("a", {
          onClick: function onClick() {
            _this3.electToChange();
            return false;
          }
        }, /*#__PURE__*/_react["default"].createElement("nobr", null, showChange)));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper
      }, chooser, button, changer);
    }
  }]);
}(_react["default"].Component);
_defineProperty(LanguagePicker, "propTypes", {
  onLanguagePicked: _propTypes["default"].func.isRequired,
  languages: _propTypes["default"].array.isRequired,
  initialLanguage: _propTypes["default"].string
});
_defineProperty(LanguagePicker, "defaultProps", {
  initialLanguage: null
});